import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";

import * as Styled from "../styled";
import Sidemenu from "../../../components/sidemenu";
import Header from "../../../components/header";
import InterViewInviteeCard from "../../../components/aiInterviewCard";
import { functionService } from "../../../lib/functions";
import PdfView from "../../../components/candidateAssessmentPdf";

const Wrapper = styled.div`
    display: flex;
    background-color: #f7f8f9;
`;
const RightSideWrapper = styled.div`
    display: flex;
    flex: 1;
    margin-left:250px;
    flex-direction: column;
    scroll-behavior: smooth;
    margin-top: 5px;

    height:98vh;
`;
const HeaderWrapper = styled.div`
    display: flex;
    flex: 1;
    width: 80vw;
`;
const BodyWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 9;
    overflow: auto;
`;
const BodyRowOne = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-start;

    margin: 0 20px;
    margin-top: -10px;
`;
const BodyRowTwo = styled.div`
    display: flex;
    flex: 9;
    flex-direction: column;
    margin: 0 20px 15px 20px;
    background-color: white;
    border-radius: 8px;
`;

const AiInterViewStatus = () => {
    const [data, setdata] = useState();
    const [nameRequired,setNameRequired]=useState()
    const {
        state: { test_id, title },
    } = useLocation();

    const getStatusOfTest = async () => {
        try {
            const {
                response: {
                    data: { data },
                },
            } = await functionService.post(
                "/machineinterview/mock-assessment-details",
                {
                    test_id: test_id,
                }
            );
            setdata(data?.result);
            setNameRequired(data?.name_required)
        } catch (error) {}
    };

    useEffect(() => {
        getStatusOfTest();
    }, []);

    return (
        <Wrapper>
            <div style={{position:'absolute',zIndex:'100'}}>
                <Sidemenu />
            </div>

            <RightSideWrapper>

                <HeaderWrapper>
                    <Header />
                </HeaderWrapper>

                <BodyWrapper>
                    <BodyRowOne>
                        <p
                            style={{
                                fontWeight: 700,
                                fontSize: "24px",
                                textAlign: "left",
                            }}
                        >
                            {title}
                        </p>
                    </BodyRowOne>
                    <BodyRowTwo>
                        <div style={{ display: "flex", padding: "0 30px" }}>
                            <p style={{ display: "flex", width:"40%" }}>
                                Invitee Details
                            </p>
                            <p style={{ display: "flex", flex: 1 }}>Status</p>
                            <p style={{ display: "flex", flex: 1 }}>Score</p>
                            <p style={{ display: "flex", flex: 1 }}>
                                Invited On
                            </p>
                            <p style={{ display: "flex", flex: 1 }}>Action</p>
                        </div>
                        <div style={{ border: "1px solid #EFEFF0" }}>
                            {data?.map((i) => {
                                return (
                                    <div key={i}>
                                        {<InterViewInviteeCard data={i} nameRequired={nameRequired} />}
                                    </div>
                                );
                            })}
                        </div>
                    </BodyRowTwo>
                </BodyWrapper>
            </RightSideWrapper>
        </Wrapper>
    );
};

export default AiInterViewStatus;
